module.exports = __webpack_public_path__ + "media/images/phone-c8abb7412cf95a88a646e445f2ba3e51.svg";